import { render, staticRenderFns } from "./TutorialDetail.vue?vue&type=template&id=8233ee02&scoped=true"
import script from "./TutorialDetail.vue?vue&type=script&lang=js"
export * from "./TutorialDetail.vue?vue&type=script&lang=js"
import style0 from "./TutorialDetail.vue?vue&type=style&index=0&id=8233ee02&prod&lang=scss&scoped=true"
import style1 from "./TutorialDetail.vue?vue&type=style&index=1&id=8233ee02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8233ee02",
  null
  
)

export default component.exports